import { AttachIcon, TelegramIcon } from '../icons';

/** Мок-телефон с чатом в Telegram (секция «Что вы получаете»). */
export function PhoneMockup() {
  return (
    <div className="relative mx-auto w-[260px] max-w-full rounded-[40px] bg-ink p-2 shadow-ink sm:w-[300px]">
      <div className="overflow-hidden rounded-[34px] bg-white">
        <div className="flex items-center justify-between px-5 pt-3 text-[12px] font-semibold text-ink">
          <span>9:41</span>
          <span className="h-5 w-20 rounded-full bg-ink" aria-hidden />
          <span className="flex items-center gap-1" aria-hidden>
            <span className="h-2.5 w-4 rounded-sm bg-ink/80" />
            <span className="h-2.5 w-5 rounded-sm border border-ink/40" />
          </span>
        </div>

        <div className="mt-1 flex items-center gap-3 border-b border-line px-4 py-2.5">
          <span className="text-accent" aria-hidden>
            ‹
          </span>
          <div className="flex flex-1 flex-col items-center">
            <span className="text-[14px] font-semibold text-ink">lex.ai</span>
            <span className="text-[11px] text-muted-400">бот · онлайн</span>
          </div>
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-ink">
            <TelegramIcon className="h-4 w-4 text-gold" />
          </div>
        </div>

        <div className="flex h-[320px] flex-col gap-2.5 overflow-hidden bg-linear-to-b from-[#cce0ed] to-[#deebd1] p-3">
          <span className="mx-auto rounded-full bg-[#3c5464]/38 px-2.5 py-1 text-[11px] font-medium text-white">
            Сегодня
          </span>

          <div className="max-w-[86%] rounded-2xl rounded-bl-md bg-white px-3 py-2 shadow-sm">
            <p className="text-[12.5px] font-semibold leading-snug text-ink">
              Здравствуйте! Я юрист lex.ai. Опишите вашу ситуацию — подскажу, что делать.
            </p>
            <span className="mt-1 block text-right text-[10px] text-muted-400">9:41</span>
          </div>

          <div className="max-w-[86%] rounded-2xl rounded-bl-md bg-white px-3 py-2 shadow-sm">
            <p className="text-[12.5px] font-semibold leading-snug text-ink">
              Пришла повестка, хотя у меня отсрочка по учёбе. Что делать?
            </p>
            <span className="mt-1 block text-right text-[10px] text-muted-400">9:42</span>
            <button
              type="button"
              className="mt-2 w-full rounded-[10px] bg-[#3c5464]/42 py-2 text-[12px] font-semibold text-white"
            >
              Открыть чат с юристом ↗
            </button>
          </div>

          <div className="max-w-[86%] rounded-2xl rounded-bl-md bg-white px-3 py-2 shadow-sm">
            <p className="text-[12.5px] font-semibold leading-snug text-ink">
              Спасибо! Разберём и подготовим заявление в военкомат.
            </p>
            <span className="mt-1 block text-right text-[10px] text-muted-400">9:43</span>
          </div>
        </div>

        <div className="flex items-center gap-2 border-t border-line px-3 py-2.5">
          <span className="flex items-center gap-1.5 rounded-full bg-accent px-3 py-1.5 text-[12px] font-semibold text-white">
            Меню
          </span>
          <span className="flex flex-1 items-center gap-2 rounded-full border border-line-strong px-3 py-1.5 text-[12px] text-muted-400">
            Сообщение
            <AttachIcon className="ml-auto h-4 w-4" />
          </span>
        </div>
      </div>
    </div>
  );
}
